import * as React from "react";

import * as moment from "moment";
import { Button, Divider, Grid, Tab, Segment } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { getAdminProfessionDisplayName } from "@teamprevent/common/adminUser/models";

import { CoreDetailProps, DetailProps } from "../Detail";
import DeleteButton from "../DeleteButton";
import { ADMIN_ROLES, Authorize } from "../../../../auth";

import { Link } from "redux-little-router";

export const CoreDetails: React.FunctionComponent<CoreDetailProps> = (props) => (
    <Grid>
        {props.adminUser.firstName && <Detail label="First Name" value={props.adminUser.firstName} labelWidth={5} valueWidth={11} />}
        {props.adminUser.surname && <Detail label="Surname" value={props.adminUser.surname} labelWidth={5} valueWidth={11} />}
        <Detail label="Email Address" value={props.adminUser.emailAddress || ""} labelWidth={5} valueWidth={11} />
        <Detail label="Locum User" value={props.adminUser.isLocumUser ? "Yes" : "No"} labelWidth={5} valueWidth={11} />
        {props.adminUser.isLocumUser && <Detail label="Locum Full Name" value={props.adminUser.locumUserFullName || ""} labelWidth={5} valueWidth={11} />}
        <Detail label="Mobile Number" value={props.adminUser.mobileNumber || ""} labelWidth={5} valueWidth={11} />
        <Detail label="Roles" value={(props.adminUser.rolesNames && props.adminUser.rolesNames.join(", ")) || ""} labelWidth={5} valueWidth={11} />
        <Detail label="Report QA" value={props.adminUser.reportQA ? "Yes" : "No"} labelWidth={5} valueWidth={11} />
        <Detail label="Profession"
            value={getAdminProfessionDisplayName(props.adminUser.profession)}
            labelWidth={5}
            valueWidth={11}
        />
        <Detail label="Qualification" value={props.adminUser.qualification || ""} labelWidth={5} valueWidth={11} />
        <Detail label="Start Time" value={props.adminUser.workingDayStartTime || ""} labelWidth={5} valueWidth={11} />
        <Detail label="Finish Time" value={props.adminUser.workingDayEndTime || ""} labelWidth={5} valueWidth={11} />
        <Detail
            label="Working Week"
            value={(props.adminUser.workingDays || []).sort().map(day => moment.weekdays(true, day)).join(", ")}
            labelWidth={5}
            valueWidth={11}
        />
    </Grid>
);

const CoreDetailsWithActions: React.FunctionComponent<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails adminUser={props.adminUser} />
            <Authorize roles={[ADMIN_ROLES.SYSTEM_ADMIN]}>
                <Divider />
                <Segment basic clearing vertical>
                    <DeleteButton disabled={props.adminUser.hasAssignedTasks} />
                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
                </Segment>
            </Authorize>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
